import { render } from "./PlatMerchantDetail.vue?vue&type=template&id=65016fab&scoped=true"
import script from "./PlatMerchantDetail.vue?vue&type=script&lang=js"
export * from "./PlatMerchantDetail.vue?vue&type=script&lang=js"

import "./PlatMerchantDetail.vue?vue&type=style&index=0&id=65016fab&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65016fab"],['__file',"src/views/h5/common/plat/merchant/PlatMerchantDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65016fab"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65016fab', __exports__)) {
    api.reload('65016fab', __exports__)
  }
  
  module.hot.accept("./PlatMerchantDetail.vue?vue&type=template&id=65016fab&scoped=true", () => {
    api.rerender('65016fab', render)
  })

}


export default __exports__